/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @fileoverview gRPC-Web generated client stub for yourpass.naming.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import * as google_protobuf_timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb';

import { Record, SubscribeRequest } from './naming_pb';

export class NamingServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(
    hostname: string,
    credentials?: null | { [index: string]: string },
    options?: null | { [index: string]: string }
  ) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoSubscribe = new grpcWeb.AbstractClientBase.MethodInfo(
    Record,
    (request: SubscribeRequest) => {
      return request.serializeBinary();
    },
    Record.deserializeBinary
  );

  subscribe(request: SubscribeRequest, metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ + '/yourpass.naming.v1.NamingService/Subscribe',
      request,
      metadata || {},
      this.methodInfoSubscribe
    );
  }
}
